<template>
  <div class="p-grid" style="margin-top: 200px">
    <Toast position="bottom-left" />
    <Panel header="ورود به حساب کاربری" class="p-col-4 p-offset-4">
      <form>
        <div class="p-fluid">
          <div class="p-field">
            <label>نام کاربری</label>
            <InputText v-model="userName" type="text" />
          </div>
          <div class="p-field">
            <label>رمز عبور</label>
            <InputText v-model="password" type="password" />
          </div>
        </div>
        <div>
          <Button
            label="ورود"
            @click="handleSubmit"
            type="submit"
            class="p-button-danger p-mr-2"
          />
        </div>
      </form>
    </Panel>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userName: "",
      password: "",
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      if (this.password.length > 0) {
        const baseUrl =
          process.env.NODE_ENV === "production"
            ? "https://nextapi.logonomy.ir"
            : "http://localhost:5051";

        axios
          .post(`${baseUrl}/api/Auth/GetToken`, {
            userName: this.userName,
            password: this.password,
          })
          .then((res) => {
            localStorage.setItem("jwt", res.data.token);
            this.$router.push({ path: `/` });
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: error.response.data,
              life: 3000,
            });
          });
      }
    },
  },
};
</script>

<style scoped>
.p-offset-4 {
  margin-right: 33.33333333%;
  margin-left: 0;
}
body {
  min-height: 0;
  overflow-x: hidden;
}
</style>>
